import React from 'react';
import { motion } from 'framer-motion';

const tools = ['HubSpot', 'Salesforce', 'Zendesk', 'Freshdesk', 'Jira', 'Slack', 'Email', 'SMS', 'Scheduling & Booking Tools'];

const Integrations = () => (
  <section className="py-20 border-t" style={{ background: '#0d0d0d', borderColor: '#1a1a1a' }}>
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-12">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#4ade80' }}>Integrations</p>
        <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#f1f1f1' }}>Fits into your existing workflow.</h2>
        <p className="text-base max-w-xl leading-relaxed" style={{ color: '#888' }}>
          We configure integrations during implementation. You don't wire anything up yourself.
        </p>
      </motion.div>
      <div className="flex flex-wrap gap-3">
        {tools.map((tool, i) => (
          <motion.span key={i} initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
            transition={{ delay: i * 0.05 }}
            className="px-4 py-2.5 rounded-lg text-sm font-medium border" style={{ background: '#111', borderColor: '#1f1f1f', color: '#ccc' }}>
            {tool}
          </motion.span>
        ))}
      </div>
    </div>
  </section>
);

export default Integrations;